<script>
import BrandedTextElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/BrandedTextElement.vue";
import BrandedTextOptions from "%/dynamic-components/render-engine/bundles/branded-text-options";

export default {
  name: "BrandedHeadingElement",
  elementPanelSettings: {
    displayName: "Heading",
    displayIcon: "text",
    elementType: "element",
    elementGroup: "text",
    displayAsWysiwyg: true,
  },
  extends: BrandedTextElement,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "heading",
    }),
  ],
};
</script>
